export default [
    {
        path: '/return-request/emons/config',
        name: 'return_request_emons_config',
        component: () => import('@src/return-request/emons-return-request-config.vue'),
        meta: {
            title: 'Einstellungen - Rückholer',
            route: 'ROLE_EMONS_RETURN_REQUEST_CONFIG',
        },
    },
];
